<template>
  <el-dialog title="下载" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" :model="formData" label-width="100px" size="small">
      <el-form-item label="下载类型" prop="downloadType">
        <!-- <el-select v-model="formData.downloadType" placeholder="请选择下载类型" style="width: 100%">
          <el-option label="申报材料" value="declaration"></el-option>
          <el-option label="推荐意见" value="recommendation"></el-option>
        </el-select> -->
          <el-radio-group v-model="formData.downloadType">
    <el-radio label="declaration">申报材料</el-radio>
    <el-radio v-if="currentRow.downloadType!='declaration'" label="recommendation">推荐意见</el-radio>
  </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleDownload" :loading="loading">下载</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getBaseUrl } from '@/config'

export default {
  name: 'DownloadDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      currentRow: {},
      formData: {
        downloadType: 'declaration'
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.currentRow = row
      console.log("currentRow====", this.currentRow.downloadType);
      this.formData.downloadType = 'declaration'
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.currentRow = {}
    },
    handleDownload() {
      if (!this.formData.downloadType) {
        this.$message.warning('请选择下载类型')
        return
      }
      this.loading = true

      if (this.formData.downloadType === 'declaration') {
        this.downloadDeclaration()
      } else {
        this.downloadRecommendation()
      }
    },
    downloadDeclaration() {
      this.dialogVisible = false
      this.loading = false
      window.open(`${getBaseUrl()}/frontend/opinion/projectPdf?token=${window.sessionStorage.getItem('token')}&xid=${this.currentRow.xid}`)
    },
    downloadRecommendation() {
      this.dialogVisible = false
      this.loading = false
      window.open(`${getBaseUrl()}/frontend/opinion/recommendPdf?token=${window.sessionStorage.getItem('token')}&project_xid=${this.currentRow.xid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
